import type { PlatformAdapter } from './types';

export const webPlatform: PlatformAdapter = {
  kind: 'web',
  isDesktopShell: false,
  getAppLabel() {
    return 'Spox Web';
  },
  async openExternal(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
  },
};
